var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',_vm._b({attrs:{"dot":"","value":_vm.isVisible,"color":"#FF505F"}},'v-badge',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }